<template>    

    <section class="table pb70">

        <div class="box">

            <div class="table__header">
                <h1>{{title}}</h1>
                <div class="btns">
                    <router-link class="btn" :to="{ name: 'scriptTypeList' }">
                        <i class="fal fa-backspace"></i>
                    </router-link>
                </div>
            </div>
            <div class="table__form">

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Flaggato</strong>
                    </div>
                    <div class="checkbox-wrapper-6">
                        <input
                            class="tgl tgl-light" id="cb_offline_conversion"
                            type="checkbox" v-model="scriptType.flagged" :checked="scriptType.flagged"
                        />
                        <label class="tgl-btn" for="cb_offline_conversion"></label>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Classe script</strong>
                    </div>
                    <input type="text" v-model="scriptType.script_class">
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Nome</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id">
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['script']">
                                <div class="mt10" style="margin-top: 10px;">
                                    <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.script" @click="deeplTranslate('script', translations[language.id].script)">
                                        <span v-if="!translating.script">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Descrizione</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id">
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                    plugins: ['lists link image paste help wordcount code'],
                                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link code'
                                }" v-model="translations[language.id]['description']"></editor>
                                <div class="mt10" style="margin-top: 10px;">
                                <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.description" @click="deeplTranslate('description', translations[language.id].description)">
                                    <span v-if="!translating.description">Traduci con AI</span>
                                    <span v-else>
                                        <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                    </span>
                                </button>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="bcm_action" style="display: flex; justify-content: space-between;">

                    <div>
                        <div>
                            <div><strong>Created</strong>: {{ scriptType.requestLogCreate }}</div>
                        </div>
                        <div>
                            <div><strong>Updated</strong>: {{ scriptType.requestLogUpade }}</div>
                        </div>
                    </div>

                    <input type="button" :value="btn" v-on:click="saveScriptType()">
                </div>
            </div>

        </div>
    </section>

</template>
<script>

    import { mapGetters } from 'vuex'
    import Editor from '@tinymce/tinymce-vue';
    import axios from "axios";
    import langMap from '../../../assets/twocharlanguage.json';
    import flagMixin from '../../../mixins/flagMixin';

    export default {
        mixins: [flagMixin],
        data: () => ({
            title: 'Categorie Cookie',
            translating: {
                script: false,
                description: false
            }
        }),
        components: {
            'editor': Editor // <- Important part
        },

        computed: {

            ...mapGetters(
                {
                    scriptType: 'scriptTypesModule/scriptType',
                    languages: 'scriptTypesModule/languages',
                    languageSelected: 'scriptTypesModule/languageSelected',
                    translations: 'scriptTypesModule/translations',
                    hasPermission: 'hasPermission'
                }
            ),

            setTitle : function() {

                var ret = {};

                if(this.$route.params.action == 'create'){

                    ret.title = "Create"

                } else {

                    ret.title = "Edit"

                }
                return ret

            },

            btn: function(){
                if(this.$route.params.action == 'create'){
                    return "Salva"
                } else {
                    return "Modifica"
                }
            }


        },

        methods: {
            loadScriptType () {
                this.$store.dispatch('scriptTypesModule/loadScriptType', {urlToConnect: 'script_types/'+this.$route.params.id+'/edit', id: this.$route.params.id})
            },

            createScriptType () {
                this.$store.dispatch('scriptTypesModule/createScriptType', {urlToConnect: 'script_types/create'})
                this.$store.state.scriptTypesModule.scriptType.requestLogCreate = '/';
                this.$store.state.scriptTypesModule.scriptType.requestLogUpade = '/';
            },

            languageSelect (slug) {
                this.$store.dispatch('scriptTypesModule/languageSelect', {slug: slug})
            },

            saveScriptType(){
                
                var parameters = {
                    urlToConnect: 'script_types',
                    methodToConnect: 'post',
                    flagged: this.$store.state.scriptTypesModule.scriptType.flagged,
                    script_class: this.$store.state.scriptTypesModule.scriptType.script_class,
                    translations: this.$store.state.scriptTypesModule.translations,
                }
                
                if(this.$route.params.action == 'edit'){
                    parameters.urlToConnect = 'script_types/' + this.$route.params.id;
                    parameters._method = "patch";
                }


                this.$store.dispatch('scriptTypesModule/saveScriptType', parameters).then((data) => {
                    if (this.$route.params.action === 'create') {
                        if(this.hasPermission('ScriptTypes', 'edit')){
                            this.$router.replace("/scripttypes/" +data.id+ "/edit")
                        } else {
                            this.$router.replace("/scripttypes")
                        }
                    }
                })

            },

            async deeplTranslate(field, textToTranslate) {
                if (this.translating[field]) return;

                this.$set(this.translating, field, true);

                const selectedLang = this.languageSelected;
                const languageObj = this.languages.find(l => l.slug === selectedLang);
                const sourceLang = langMap[languageObj.slug.toLowerCase()];

                const targetLangs = this.languages
                    .filter(l => {
                        const iso2 = langMap[l.slug.toLowerCase()];
                        return iso2 && iso2 !== sourceLang;
                    })
                    .map(l => langMap[l.slug.toLowerCase()]);

                if (!textToTranslate || !targetLangs.length) {
                    this.$set(this.translating, field, false);
                    return;
                }

                // 🔐 PREPARAZIONE TESTO (HTML SAFE)
                const { text, tokens } = this.prepareForTranslation(textToTranslate);

                try {
                    const payload = {
                        Text: [text],
                        SourceLang: sourceLang,
                        TargetLanguages: targetLangs,
                        Context: 'cookie description'
                    };

                    const response = await axios.post('/deepl-translate', payload);
                    const data = response.data;

                    if (!data.IsSucceded) {
                        throw new Error(data.Errors || 'Errore traduzione');
                    }

                    data.Data.forEach(translation => {
                        if (!translation || !translation.Translations || !translation.Translations.length || !translation.Translations[0]) {
                            return;
                        }

                        const translatedRaw = translation.Translations[0].Text;
                        const langCode = translation.Translations[0].TargetLanguage;

                        if (!translatedRaw || !translatedRaw.trim()) {
                            console.warn('Traduzione vuota per', langCode);
                            return;
                        }

                        const langObj = this.languages.find(l => {
                            if (!l.slug) return false;
                            const iso2 = langMap[l.slug.toLowerCase()];
                            return iso2 && iso2 === langCode;
                        });

                        if (!langObj) return;

                        if (!this.translations[langObj.id]) {
                            this.$set(this.translations, langObj.id, {});
                        }

                        const finalText = this.restoreAfterTranslation(translatedRaw, tokens);
                        this.$set(this.translations[langObj.id], field, finalText);
                    });

                } catch (err) {
                    console.error('Errore durante la traduzione:', err);
                } finally {
                    this.$set(this.translating, field, false);
                }
            },

            prepareForTranslation(html) {
                if (!html) return { text: '', tokens: [] };

                const tokens = [];
                let index = 0;

                const tokenize = match => {
                    const key = `[${index}]`;
                    tokens.push({ key, value: match });
                    index++;
                    return key;
                };

                // 🔒 Protegge i placeholder tipo |*LISTA DOMINI*| affinché DeepL non li traduca/alteri
                let text = html.replace(/\|\*.*?\*\|/g, tokenize);

                text = text.replace(/<[^>]+>/g, match => {
                    if (/^<br\s*\/?>$/i.test(match)) {
                        return match;
                    }

                    return tokenize(match);
                });

                return { text, tokens };
            },

            restoreAfterTranslation(translatedText, tokens) {
                let result = translatedText;

                tokens.forEach(t => {
                    result = result.replaceAll(t.key, t.value);
                });

                // normalizza BR duplicati
                result = result.replace(/(<br\s*\/?>\s*){2,}/gi, '<br />');

                return result;
            }

        },
        watch: {
            '$route' () {
                if(this.$route.params.action == 'edit') {
                    this.loadScriptType()
                } else if(this.$route.params.action == 'create') {
                    this.createScriptType()
                }
            }
        },
        created () {
            if(this.$route.params.action == 'edit') {
                this.loadScriptType()
            } else if(this.$route.params.action == 'create') {
                this.createScriptType()
            }
        }




    }
</script>